module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Euro-e54af0559a1f053db147dcf258985e72.svg";